module.exports = __webpack_public_path__ + "img/depadark.df88aa71.png";